import { schema } from 'normalizr';

export const notificationsSchema = new schema.Entity('notifications');
